


































import { computed, defineComponent, ref } from "@vue/composition-api";
import { TagInfo, TagInfoType } from "@scrile/api-provider/dist/api/TagsProvider";
import useTags from "@/hooks/useTags";
import BaseInput from "@/components/BaseInput";
import CustomScroll from "@/components/CustomScroll";
import TagItem from "@/components/TagItem";

export default defineComponent({
  name: "HashtagsSetupView",
  components: { CustomScroll, TagItem, BaseInput },
  props: {
    selectedTags: { type: Array as () => string[], default: () => [] },
  },
  setup(props, { emit }) {
    const categoryValue = ref("");
    const { getTags, tags } = useTags();
    const maxSelection = 8;

    const searchedTags = computed(() => {
      return tags.value
        .sort((a, b) => {
          const normalizeA = a.title.toLowerCase();
          const normalizeB = b.title.toLowerCase();
          return normalizeA > normalizeB ? 1 : normalizeA < normalizeB ? -1 : 0;
        })
        .filter(tag => tag.title.toLowerCase().includes(categoryValue.value.toLowerCase()));
    });

    const selectTag = (tag: TagInfo, value: boolean) => {
      if (props.selectedTags?.length >= maxSelection && value) return;
      emit("toggleTag", tag, value);
    };

    getTags(TagInfoType.POSTS);

    return {
      tags,
      searchedTags,
      categoryValue,
      selectTag,
    };
  },
});
